(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elements = document.querySelectorAll('[data-hh-reveal]');
    if (!elements.length || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    }), { threshold: 0.15 });
    elements.forEach(element => { element.classList.add('hh-reveal'); observer.observe(element); });
    window.addEventListener('beforeprint', () => elements.forEach(element => element.classList.add('is-revealed')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-cart"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('#wb-cart-form .wb-cart__update').forEach(button => { button.hidden = true; });
  document.addEventListener('quantity-selector:update', event => {
    const form = event.target.closest('#wb-cart-form');
    if (!form || form.dataset.submitting === 'true') return;
    const update = form.querySelector('[name="update"]');
    if (!form.reportValidity()) return;
    form.dataset.submitting = 'true';
    form.requestSubmit(update);
  });

  } catch(e) { console.error(e); }
})();
})();
